// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-projects_common_src_lib_core_utils_rxjs_toggle-execution-state_ts-projects_common_src-2b9502":"bca1b018fb2f3acb","projects_web_src_app_features_auth_auth_module_ts":"0c06891ddb76f6b3","projects_web_src_app_features_dashboard_dashboard_module_ts":"4f7fe9cbcc9e9240"}[chunkId] + ".js";
};